import { batchActions } from './utils';
import { setData } from './data';
import { setStatus, unsetStatus } from './status';
import { LOADING, ERROR, selectNetworkFollowersStatus, selectDateRange } from './selectors';
import { toJSON, PODCASTERS_SERVICE } from '../lib/Request';
import { DateRangeWithLabel, Thunk, Follower } from '../types';

export const loadNetworkFollowers = (networkId: string): Thunk => async (
  dispatch,
  getState,
  { request },
) => {
  const key = 'networkFollowers';

  const { startDate, endDate } = selectDateRange(getState()) as DateRangeWithLabel;
  const endpoint = `${PODCASTERS_SERVICE}/v0/networks/${networkId}/followers?start=${startDate}&end=${endDate}`;

  /* istanbul ignore next */
  if (selectNetworkFollowersStatus(getState()) === LOADING) return;

  dispatch(setStatus({ [key]: LOADING }, 'audience/LOAD_NETWORK_FOLLOWERS_REQUEST'));

  try {
    const { counts: data }: { counts: Follower[] } = await request.get(endpoint).then(toJSON);

    dispatch(
      batchActions(
        [setData({ [key]: data }), unsetStatus([key])],
        'audience/LOAD_NETWORK_FOLLOWERS_SUCCESS',
      ),
    );
  } catch (err) {
    switch (err.name) {
      case 'ResponseError':
      case 'TokenError': {
        dispatch(setStatus({ [key]: ERROR }, 'audience/LOAD_NETWORK_FOLLOWERS_ERROR'));
        break;
      }

      /* istanbul ignore next */
      default:
        throw err;
    }
  }
};
